module.exports = __webpack_public_path__ + "static/media/rules_and_consequences_ignoring_3.a2498510.png";